import React from 'react'
import search from "../../../assets/images/search.svg"
const Search = ({title}) => {
  return (
    <div className='search flex-between'>
     <input placeholder={title}  />
     <img src={search} alt='search' />
    </div>
  )
}

export default Search